module.exports = __webpack_public_path__ + "3e6102838442edc8dc3f215c50030f16.png";